import React, { memo } from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { DialogActions, Grid } from "@material-ui/core";

import DriverInputs from "./driverInputs";
import SaveChangesButton from "./saveChangesButton";
import DriverCheckboxes from "./driverCheckboxes";

const CreateDriverForm = ({ vehicles, sections, isSubmitting, dirty }) => (
  <>
    <Grid container spacing={2}>
      <Grid item xs={7}>
        <Field
          component={TextField}
          name="driverName"
          type="text"
          label="Driver Name"
          placeholder="Forename Surname"
          variant="outlined"
          fullWidth
          data-testid="add-driver-name"
          inputProps={{ maxLength: 32 }}
        />
      </Grid>
      <Grid item xs={5}>
        <Field
          component={TextField}
          name="displayName"
          type="text"
          placeholder="Display Name"
          helperText="Driver Display Name"
          variant="outlined"
          fullWidth
          data-testid="add-driver-display-name"
        />
      </Grid>
    </Grid>
    <DriverInputs isDisabled={false} vehicles={vehicles} sections={sections} />
    <DriverCheckboxes isDisabled={false} />
    <DialogActions>
      <SaveChangesButton disabled={!dirty || isSubmitting} />
    </DialogActions>
  </>
);

export default memo(CreateDriverForm);
